// @flow

import React from 'react';

type Props = {
  assetPath: string;
}

const ChaseField = (props: Props) => {
  const backgrounds = [
    `${props.assetPath}assets/games/chase_game/tikkertje-laag-achtergrond.png`,
    `${props.assetPath}assets/games/chase_game/tikkertje-laag-extra.png`,
    `${props.assetPath}assets/games/chase_game/tikkertje-laag3.png`,
    `${props.assetPath}assets/games/chase_game/tikkertje-laag2.png`,
  ];
  return (
    <div className="chase__background">
      <img src={backgrounds[3]} alt={''} className="chase__background-front-left" />
      <img src={backgrounds[2]} alt={''} className="chase__background-front-right" />
      <img src={backgrounds[1]} alt={''} className="chase__background-middle" />
      <img src={backgrounds[0]} alt={''} className="chase__background-back" />
    </div>
  );
};

export default ChaseField;
